// src/utils/CountdownCircle.jsx
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify"; // ✅ استيراد toast
import "./CountdownCircle.css"; // لو عندك CSS للدائرة

export default function CountdownCircle({ message, duration, closeOnUserActivity, theme }) {
  const [timeLeft, setTimeLeft] = useState(duration / 1000);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    // إذا المستخدم تفاعل نغلق الرسالة
    const userEvents = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    const handleUserActivity = () => {
      if (closeOnUserActivity) toast.dismiss();
    };
    userEvents.forEach((e) => window.addEventListener(e, handleUserActivity));

    return () => {
      clearInterval(interval);
      userEvents.forEach((e) => window.removeEventListener(e, handleUserActivity));
    };
  }, [closeOnUserActivity]);

  const percentage = (timeLeft / (duration / 1000)) * 100;

  return (
    <div className={`countdown-circle ${theme}`}>
      <svg viewBox="0 0 36 36" className="circular-chart">
        <path
          className="circle-bg"
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circle"
          strokeDasharray={`${percentage}, 100`}
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text x="18" y="20.35" className="percentage">{timeLeft}s</text>
      </svg>
      <div className="countdown-message">{message}</div>
    </div>
  );
}
